import {
  defineComponent,
  ref,
  computed,
  watch,
  nextTick,
  inject,
  onMounted,
  onBeforeUnmount,
} from "/Scripts/vue.esm-browser.js";

import FilterBoxMobile from "/Component/Shop/mobile/FilterBoxMobile.js";
import DestinationDropdown from "/Component/Promotions/Keyword/DestinationDropdown.js";
import DestinationNav from "/Component/Promotions/Keyword/DestinationNav.js";

const html = String.raw;

export default defineComponent({
  name: "DestinationTopNav",
  props: {
    filteredDataByGroup: {
      type: Array,
      required: true,
    },
  },
  components: {
    FilterBoxMobile,
    DestinationDropdown,
    DestinationNav,
  },
  emits: [],
  setup(props, { emit }) {
    const loading = inject("loading");
    const dept = inject("dept");
    let specialBtnNodes = [];
    let popupNodes = [];
    let anchorListEl = null;
    let anchorContainerEl = null;
    let eventsBound = false;

    const destinations = computed(() => {
      let specialCities = ["台中", "高雄"];
      //如果有dept，則不顯示特殊城市分類
      if (dept.value) {
        specialCities = [];
      }
      const destMap = new Map();
      let specialCounter = 0;
      const ensureDest = (label, isSpecial = false) => {
        if (!destMap.has(label)) {
          destMap.set(label, {
            label,
            isSpecialDeparture: isSpecial,
            promotionAnchors: [],
            specialIndex: null,
          });
        }
        return destMap.get(label);
      };

      props.filteredDataByGroup.forEach((element) => {
        const isSpecial = specialCities.includes(element.departureName);
        if (isSpecial) {
          const label = `${element.departureName}出發`;
          const dest = ensureDest(label, true);
          element.areas?.forEach((area) => {
            area.promotions?.forEach((promotion) => {
              const anchor = promotion.promotionData?.anchor;
              if (anchor && !dest.promotionAnchors.includes(anchor)) {
                dest.promotionAnchors.push(anchor);
              }
            });
          });
          if (dest.promotionAnchors.length && dest.specialIndex === null) {
            dest.specialIndex = specialCounter++;
          }
          return;
        }

        element.areas?.forEach((area) => {
          const label = area.area;
          const dest = ensureDest(label, false);
          area.promotions?.forEach((promotion) => {
            const anchor = promotion.promotionData?.anchor;
            if (anchor && !dest.promotionAnchors.includes(anchor)) {
              dest.promotionAnchors.push(anchor);
            }
            if (dest.promotionAnchors.length && dest.specialIndex === null) {
              dest.specialIndex = specialCounter++;
            }
          });
        });
      });

      return Array.from(destMap.values());
    });
    const popupList = computed(() =>
      destinations.value.filter((d) => d.specialIndex !== null),
    );

    // 追蹤當前 active 的目的地
    const activeDestination = ref("");

    // 保存 observer 實例
    let observerInstance = null;

    const handleHistory = (destination) => {
      const url = new URL(window.location.href);

      if (destination) {
        url.searchParams.set("location", destination);
      } else {
        url.searchParams.delete("location");
      }

      // 只改網址，不重整頁面
      window.history.replaceState(null, "", url.toString());
    };
    // 處理錨點點擊
    const handleAnchorClick = (destination, isSpecial) => {
      const destinationLabel = destination?.label || destination;
      handleHistory(destinationLabel);
      let isSpecialDeparture =
        destinationLabel === "台中出發" || destinationLabel === "高雄出發";
      let targetElement;

      if (isSpecialDeparture) {
        // 移除"出發"取得城市名
        const cityName = destinationLabel.replace("出發", "");
        targetElement = document.querySelector(
          `[data-departure-name="${cityName}"]`,
        );
      } else {
        // 對於一般地點，直接使用destination
        targetElement = document.querySelector(
          `[data-location-name="${destinationLabel}"]`,
        );
      }
      if (isSpecial) {
        targetElement = targetElement.closest(".block");
      }

      if (targetElement) {
        const topNav = document.querySelector(".destination_topnav");
        const header = document.querySelector(".topbanner");

        const targetRect = targetElement.getBoundingClientRect();
        const currentScrollY = window.pageYOffset;
        const targetScrollY = targetRect.top + currentScrollY;
        // 1. 使用 window.getComputedStyle() 取得所有計算後的樣式
        const styles = window.getComputedStyle(targetElement);
        // 2. 從樣式物件中取得 padding-top 的值
        const paddingTopValue = styles.paddingTop; // 或者使用 styles['padding-top']
        const paddingTopAsNumber =
          parseInt(paddingTopValue, 10) - isSpecial ? -5 : 0; // 使用 parseInt 轉換為整數

        // 判斷目標元素是在視窗上方還是下方
        const isTargetAbove = targetRect.top < 0;

        // 計算偏移量
        let offset;
        if (isTargetAbove) {
          // 目標在上方，需要加上 topNav 高度
          offset =
            topNav.offsetHeight +
            (header?.offsetHeight || 0) -
            paddingTopAsNumber;
        } else {
          // 目標在下方，不加 topNav 高度
          offset = (header?.offsetHeight || 0) - paddingTopAsNumber;
        }

        // 計算最終目標位置
        const targetPosition = targetScrollY - offset;

        // 平滑滾動到目標位置
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });

        // 立即更新 active 狀態
        activeDestination.value = destinationLabel;
      }
    };

    const handleSpecialClick = (tag) => {
      const block =
        document.querySelector(`.block.is-special[data-anchor="${tag}"]`) ||
        document.querySelector(".block.is-special");
      if (block) {
        const rect = block.getBoundingClientRect();
        const topNav = document.querySelector(".destination_topnav");
        const header = document.querySelector(".topbanner");
        const offset =
          (topNav?.offsetHeight || 0) + (header?.offsetHeight || 0);
        const targetPosition = rect.top + window.scrollY - offset;
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
      }
    };

    const refreshDomRefs = () => {
      specialBtnNodes = Array.from(
        document.querySelectorAll(".anchor_btn.is-special"),
      );
      popupNodes = Array.from(
        document.querySelectorAll(".anchor_popup_container"),
      );
      anchorListEl = document.querySelector(".anchor_list");
      anchorContainerEl = document.querySelector(".anchor_list_container");
    };

    const hideAllPopups = () => {
      popupNodes.forEach((p) => (p.style.display = "none"));
      specialBtnNodes.forEach((btn) => btn.classList.remove("is-open"));
    };

    const positionPopup = (btn, popup) => {
      const rect = btn.getBoundingClientRect();
      popup.style.left = `${rect.left}px`;
      popup.style.top = `${rect.bottom}px`;
    };

    const showPopupByIndex = (index) => {
      const btn = specialBtnNodes[index];
      const popup = popupNodes[index];
      if (!btn || !popup) return;
      hideAllPopups();
      btn.classList.add("is-open");
      popup.style.display = "block";
      positionPopup(btn, popup);
    };

    const handleMouseOver = (e) => {
      const btn = e.target.closest(".anchor_btn.is-special");
      if (!btn || !anchorContainerEl?.contains(btn)) return;
      const idx = specialBtnNodes.indexOf(btn);
      if (idx >= 0) {
        e.stopPropagation();
        showPopupByIndex(idx);
      }
    };

    const handleClickSpecial = (e) => {
      const btn = e.target.closest(".anchor_btn.is-special");
      if (!btn || !anchorContainerEl?.contains(btn)) return;
      const idx = specialBtnNodes.indexOf(btn);
      if (idx >= 0) {
        e.stopPropagation();
        showPopupByIndex(idx);
      }
    };

    const handleScrollHide = () => hideAllPopups();

    const handleDocumentClick = (e) => {
      if (popupNodes.some((p) => p.contains(e.target))) return;
      if (e.target.closest(".anchor_btn.is-special")) return;
      hideAllPopups();
    };

    const handleTouchMove = () => hideAllPopups();

    const bindPopupEvents = () => {
      if (eventsBound) return;
      eventsBound = true;
      anchorContainerEl?.addEventListener("mouseover", handleMouseOver);
      anchorContainerEl?.addEventListener("click", handleClickSpecial);
      window.addEventListener("scroll", handleScrollHide);
      document.addEventListener("click", handleDocumentClick);
      anchorListEl?.addEventListener("touchmove", handleTouchMove);
    };

    onBeforeUnmount(() => {
      anchorContainerEl?.removeEventListener("mouseover", handleMouseOver);
      anchorContainerEl?.removeEventListener("click", handleClickSpecial);
      window.removeEventListener("scroll", handleScrollHide);
      document.removeEventListener("click", handleDocumentClick);
      anchorListEl?.removeEventListener("touchmove", handleTouchMove);
      if (observerInstance) {
        observerInstance.disconnect();
      }
    });

    onMounted(() => {
      const kvElement = document.querySelector(".kv");
      const topnavElement = document.querySelector(".destination_topnav");
      if (!topnavElement) return;

      let lastScrollY = window.scrollY;

      const updateTopnavState = (event) => {
        const currentScrollY = window.scrollY;
        const isScrollingUp = currentScrollY < lastScrollY;
        if (!kvElement || !topnavElement) return;

        const leftSidebar =
          !!event.target.closest && !!event.target.closest(".leftsidebar");
        if (leftSidebar) return;
        topnavElement.classList.toggle("active", isScrollingUp);
        lastScrollY = currentScrollY;
        const kvHeight = kvElement.offsetHeight;
        const shouldBeFixed = window.scrollY > kvHeight;

        topnavElement.classList.toggle("fixed", shouldBeFixed);
        hideAllPopups();
      };

      refreshDomRefs();
      bindPopupEvents();
      window.addEventListener("scroll", updateTopnavState);
      document.addEventListener("DOMContentLoaded", updateTopnavState);

      onBeforeUnmount(() => {
        window.removeEventListener("scroll", updateTopnavState);
        document.removeEventListener("DOMContentLoaded", updateTopnavState);
      });
    });

    watch(
      popupList,
      () => {
        nextTick(() => {
          refreshDomRefs();
          hideAllPopups();
        });
      },
      { immediate: true },
    );

    // 初始化 Intersection Observer
    const initializeObserver = () => {
      // 如果已有 observer，先清理
      if (observerInstance) {
        observerInstance.disconnect();
      }

      const topNav = document.querySelector(".destination_topnav");
      const topNavHeight = topNav ? topNav.offsetHeight : 0;

      const observerOptions = {
        root: null,
        rootMargin: `-${topNavHeight + 50}px 0px -70% 0px`,
        threshold: 0,
      };

      const observerCallback = (entries) => {
        const intersectingEntries = entries.filter(
          (entry) => entry.isIntersecting,
        );

        if (intersectingEntries.length === 0) return;

        let targetDestination = null;
        let highestPriority = -1;

        intersectingEntries.forEach((entry) => {
          const element = entry.target;
          const areaName = element.getAttribute("data-area-name");
          const departureName = element.getAttribute("data-departure-name");

          if (areaName) {
            const parentDeparture = element.closest("[data-departure-name]");
            if (parentDeparture) {
              const parentDepartureName =
                parentDeparture.getAttribute("data-departure-name") || "";
              if (
                parentDepartureName &&
                (parentDepartureName === "台中" ||
                  parentDepartureName === "高雄")
              ) {
                const priority = 2;
                if (priority > highestPriority) {
                  highestPriority = priority;
                  targetDestination = `${parentDepartureName}出發`;
                }
              }
            } else {
              const priority = 1;
              if (priority > highestPriority) {
                highestPriority = priority;
                targetDestination = areaName;
              }
            }
          } else if (
            departureName &&
            (departureName === "台中" || departureName === "高雄")
          ) {
            const priority = 2;
            if (priority > highestPriority) {
              highestPriority = priority;
              targetDestination = `${departureName}出發`;
            }
          }
        });

        if (targetDestination !== null) {
          activeDestination.value = targetDestination;
        }
      };

      observerInstance = new IntersectionObserver(
        observerCallback,
        observerOptions,
      );

      // 觀察所有具有 data-area-name 的元素
      const areaElements = document.querySelectorAll("[data-area-name]");
      areaElements.forEach((element) => {
        observerInstance.observe(element);
      });

      // 觀察所有具有 data-departure-name 的元素（只針對台中、高雄）
      const departureElements = document.querySelectorAll(
        "[data-departure-name='台中'], [data-departure-name='高雄']",
      );
      departureElements.forEach((element) => {
        observerInstance.observe(element);
      });
    };

    // 監聽 destinations 變化，當有資料時初始化 observer
    watch(
      destinations,
      (newDestinations) => {
        if (newDestinations && newDestinations.length > 0) {
          nextTick(() => {
            // 延遲執行以確保 DOM 更新完成
            setTimeout(() => {
              initializeObserver();
            }, 100);
          });
        }
      },
      { immediate: true },
    );

    const deptArray = computed(() => [
      { key: "TPE", text: "桃園", p: "Taipei", active: dept.value === "TPE" },
      { key: "TXG", text: "台中", p: "Taichung", active: dept.value === "TXG" },
      {
        key: "KHH",
        text: "高雄",
        p: "Kaohsiung",
        active: dept.value === "KHH",
      },
    ]);
    return {
      destinations,
      activeDestination,
      handleAnchorClick,
      observerInstance,
      loading,
      handleSpecialClick,
      popupList,
      deptArray,
    };
  },
  template: html`
    <div class="destination_topnav" :class="{'loading':loading}">
      <div class="topnav_region_primary">
        <div class="anchor_list_region">
          <destination-dropdown :dept-infos="deptArray"></destination-dropdown>
          <div class="anchor_list_region_container">
            <destination-nav
              :dept-info="deptArray.filter((item)=>item.active)[0]"
              :index="0"
            ></destination-nav>
            <div class="anchor_list_wrap horizontal dragscroll">
              <div class="anchor_list_container">
                <ul class="anchor_list">
                  <li
                    v-for="(destination,idx) in destinations"
                    :key="destination.label || idx"
                    :class="['anchor_btn', destination.promotionAnchors.length ? 'is-special' : '', { active: ((activeDestination === destination.label) || 
                             (activeDestination && destination.label && destination.label.includes(activeDestination)) || (!activeDestination && idx === 0)) && !loading}]"
                    @click="destination.promotionAnchors.length ? null : handleAnchorClick(destination)"
                  >
                    <template v-if="destination.promotionAnchors.length">
                      <span> {{destination.label}} </span>
                      <div class="tag-group">
                        <div
                          class="tag"
                          v-for="tag in destination.promotionAnchors"
                          :key="tag"
                        >
                          {{tag}}
                        </div>
                      </div>
                    </template>
                    <template v-else> {{destination.label}} </template>
                  </li>
                </ul>
              </div>
            </div>

            <div class="nav-link-list">
              <div class="nav_more">
                <img
                  src="/action/theme/clearanceSale/V2/images/kv/nav_more-text.png"
                  alt=""
                />
                <img
                  src="/action/theme/clearanceSale/V2/images/kv/nav_more-arrow.png"
                  alt=""
                />
              </div>
              <destination-nav
                v-for="(item,index) in deptArray.filter((item)=>!item.active)"
                :dept-info="item"
                :key="item.key"
                :index="index+1"
              ></destination-nav>
            </div>
          </div>
        </div>
        <filter-box-mobile></filter-box-mobile>
      </div>
    </div>
    <div class="anchor_popup_container-list">
      <div
        class="anchor_popup_container"
        v-for="(popup, idx) in popupList"
        :key="popup.label || idx"
        style="display:none;"
      >
        <ul class="anchor_popup">
          <li
            class=" is-special"
            v-for="tag in popup.promotionAnchors"
            :key="tag"
            @click="handleAnchorClick(tag,true)"
          >
            {{tag}}
          </li>
          <li @click="handleAnchorClick(popup)">{{popup.label}}</li>
        </ul>
      </div>
    </div>
  `,
  methods: {},
});
